module.exports = __webpack_public_path__ + "static/media/icon-white-red-Content-2.0ae094dd.0ae094dd.svg";